import cx from 'classnames';
import * as React from 'react';

import Text, { OptionalProps as TextProps } from 'components/Text';

import './styles/Copy.scss';

import { TextAlign, TextSize, TextColor } from 'components/Text';

type Props = {
  align?: TextAlign;
  children: React.ReactNode;
  className?: string;
  color?: TextColor;
  size?: TextSize;
} & TextProps;

export default class Copy extends React.Component<Props> {
  static defaultProps = {
    align: 'left',
  };

  render() {
    const { align, children, className, size, ...others } = this.props;

    return (
      <Text
        {...others}
        align={align}
        element="div"
        size={size}
        className={cx(
          'Copy',
          align === 'center' && 'Copy--center',
          size && `Copy--${size}`,
          className
        )}>
        {children}
      </Text>
    );
  }
}
